// extracted by css-extract-rspack-plugin
export default {"overlay":"TZ0XmXth2fQcPjvX","container":"zZ9l3W_sdCEe30Bq","shimmer":"KNtpudxqZMQr4j3B"};